<template>
  <a-card style="margin: 24px 0">
    <div slot="title" class="title">
      <div class="vertical"></div>
      勘测
    </div>
    <div slot="extra" class="extra">
      <a-month-picker placeholder="选择年月" format="YYYY-MM" valueFormat="YYYY-MM" v-model="date" @change="getList" />
    </div>
    <div class="main">
      <survey-bar :data="userwaterList"></survey-bar>
    </div>
  </a-card>
</template>

<script>
import SurveyBar from '../module/survey-bar.vue'
export default {
  components: {
    SurveyBar,
  },
  data() {
    return {
      userwaterList: {},
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    //勘测柱型图数据
    getList() {
      this.$http
        .get('/pipe-network/engineering_project_reconnaissances/centre-right', {
          params: {
            date: this.date,
          },
        })
        .then((res) => {
          console.log(res.data, '用户用水波动排序')
          let list = res.data
          var xdata = []
          var sdata = []
          list.map((item) => {
            xdata.push(item.typeName)
            sdata.push(item.num)
          })
          this.userwaterList = {
            xdata: xdata,
            sdata: sdata,
            grid: {
              x: '8%', //左侧与y轴的距离
              y: '12%', //top部与x轴的距离
              x2: '2%', //右侧与y轴的距离
              y2: '12%', //bottom部与x轴的距离
            },
          }
        })
    },
  },
}
</script>

<style lang='less' scoped>
/deep/.ant-card-body {
  padding: 0;
}
.a-card {
  width: 100%;
  height: 100%;
}
.vertical {
  width: 4px;
  height: 18px;
  margin-right: 10px;
  background: #0265ff;
  border-radius: 3px;
}
.title {
  display: flex;
  align-items: center;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 16px;
  color: #101010;
  letter-spacing: 0.63px;
  font-weight: 600;
}
.extra {
  font-family: MicrosoftYaHei;
  font-size: 12px;
  color: #a7afb5;
  letter-spacing: 0.48px;
  text-align: right;
  font-weight: 400;
}
/deep/.ant-card-extra {
  padding: 0px 0;
}
.main {
  width: 100%;
  height: 269px;
}
</style>